<template>
  <div>
    <div
      class="p3_exchange"
      v-show="poptimeoutdg || poplinkexpire || popsendlinkdg"
    >
      <!---s-dg-timeoutdg-->
      <van-popup
        class="p3_bgtimeoutdg p3_dialogtimeoutdg"
        :close-on-click-overlay="false"
        v-bind:value="poptimeoutdg"
      >
        <!---s-bt-X-->
        <div class="p3_buttonX">
          <img
            class="p3_diX"
            src="../../assets/p3/images/imgX.png"
            @click="poptimeoutdg = false"
            referrerpolicy="no-referrer"
          />
        </div>
        <!---s-bt-sure-->
        <div class="p3_buttonsure">
          <img
            class="p3_disure"
            src="../../assets/p3/images/imgsure.png"
            @click="poptimeoutdg = false"
            referrerpolicy="no-referrer"
          />
        </div>
      </van-popup>
      <!---s-dg-linkexpire-->
      <van-popup
        class="p3_bglinkexpire p3_dialoglinkexpire"
        :close-on-click-overlay="false"
        v-bind:value="poplinkexpire"
      >
        <!---s-bt-X2-->
        <div class="p3_buttonX2">
          <img
            class="p3_diX2"
            src="../../assets/p3/images/imgX2.png"
            @click="poplinkexpire = false"
            referrerpolicy="no-referrer"
          />
        </div>
        <!---s-bt-sure2-->
        <div class="p3_buttonsure2">
          <img
            class="p3_disure2"
            src="../../assets/p3/images/imgsure2.png"
            @click="poplinkexpire = false"
            referrerpolicy="no-referrer"
          />
        </div>
      </van-popup>
      <!---s-dg-sendlinkdg-->
      <van-popup
        class="p3_bgsendlinkdg p3_dialogsendlinkdg"
        :close-on-click-overlay="false"
        v-bind:value="popsendlinkdg"
      >
        <!---s-bt-X3-->
        <div class="p3_buttonX3">
          <img
            class="p3_diX3"
            src="../../assets/p3/images/imgX3.png"
            @click="popsendlinkdg = false"
            referrerpolicy="no-referrer"
          />
        </div>
        <!---s-tx-sendlinktitle-->
        <div class="p3_textsendlinktitle">
          是否收下{{ userId }}的插画?
        </div>
        <!---s-s-sendcardimg-->
        <div class="p3_slicesendcardimg">
          <img
            class="p3_disendcardimg"
            :src="cardImg"
            referrerpolicy="no-referrer"
          />
        </div>
        <!---s-tx-sendcardtitle-->
        <div class="p3_textsendcardtitle">《{{ cardTitle }}》</div>
        <!---s-tx-sendlefttimes-->
        <div class="p3_textsendlefttimes">
          今日剩余获取次数：{{ leftTimes }}
        </div>
        <!---s-bt-camcelbt-->
        <div class="p3_buttoncamcelbt">
          <img
            class="p3_dicamcelbt"
            @click="popsendlinkdg = false"
            src="../../assets/p3/images/imgcamcelbt.png"
            referrerpolicy="no-referrer"
          />
        </div>
        <!---s-bt-acceptbt-->
        <div class="p3_buttonacceptbt">
          <img
            class="p3_diacceptbt"
            @click="accept"
            src="../../assets/p3/images/imgacceptbt.png"
            referrerpolicy="no-referrer"
          />
        </div>
      </van-popup>
    </div>
    <show-err ref="errObj"></show-err>
  </div>
</template>

<style scoped>
@import "../../assets/p3/css/s3.css";
</style>
<script>
import cardConfig from "@/api/states/cardconfig";
import { timeLessExchangeCard } from "@/api/apis";
import ShowErr from "@/components/showerr";
import info from "@/api/states/info";
export default {
  name: "Exchange",
  components: { ShowErr },
  data() {
    return {
      poptimeoutdg: false,
      poplinkexpire: false,
      popsendlinkdg: false,
      exchangeToken: "",
      userId: "",
      cardId: 0,
      cardImg: "",
      cardTitle: "",
      leftTimes: 0,
      errObj: null,
    };
  },
  methods: {
    mounted() {
      this.errObj = this.$refs["errObj"];
    },
    showBeSend() {
      if (!this.errObj) {
        this.errObj = this.$refs["errObj"];
      }

      let hasSendLink = false;
      let query = this.$route.query;
      if (query.exchangeToken && query.cardId && query.userId) {
        hasSendLink = true;
      }

      if (!hasSendLink) {
        return;
      }

      this.userId = query.userId;
      this.exchangeToken = query.exchangeToken;
      this.cardId = parseInt(query.cardId);
      this.cardImg = cardConfig[this.cardId].img;
      this.cardTitle = cardConfig[this.cardId].title;
      this.leftTimes = info.receiveTimes;

      if (this.leftTimes == 0) {
        this.poptimeoutdg = true;
      } else {
        this.popsendlinkdg = true;
      }
    },
    accept() {
      if (!this.errObj) {
        this.errObj = this.$refs["errObj"];
      }
      timeLessExchangeCard(this.exchangeToken)
        .then((res) => {
          if (res.code == 18) {
            this.popsendlinkdg = false;
            this.poplinkexpire = true;
          } else if (res.code == 20) {
            this.popsendlinkdg = false;
            this.poptimeoutdg = true;
          } else if (res.code == 0) {
            this.errObj.showErr("收取成功");
            this.popsendlinkdg = false;
            info.getInfo(true);
          } else {
            this.errObj.showErr(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.errObj.showErr(err);
          throw err;
        });
    },
  },
};
</script>

<style scoped>
.p3_exchange {
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 1500;
}
.p3_textsendlinktitle {
  width: 5.367rem;
  left: 1.17rem;
  text-align: center;
}
.p3_textsendcardtitle {
  width: 6rem;
  text-align: center;
  left: 0.8rem;
}

.p3_dialogsendlinkdg {
  margin-left: -0.24rem;
}

.p3_dialoglinkexpire {
  margin-left: -0.24rem;
}

.p3_dialogtimeoutdg {
  margin-left: -0.24rem;
}
.van-popup {
  background-color: transparent;
}
.p3_textsendlefttimes {
  width: 3.4rem;
}
</style>
